export default __webpack_public_path__ + "static/media/Legguards of the Membranous.a3dc54b5.jpg";